import { motion } from "framer-motion";
import { STEPS } from "@/data/content";

export const Process = () => {
  return (
    <section id="methode" data-testid="process-section" className="py-20 sm:py-24 md:py-32 bg-surface/40 border-y border-border scroll-mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-end mb-16">
          <div>
            <p className="font-mono text-xs tracking-[0.25em] uppercase text-accent mb-4">Notre méthode</p>
            <h2 className="font-heading font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl">
              Le SaaS, mais avec un humain en face.
            </h2>
          </div>
          <p className="text-muted-foreground leading-relaxed">
            On a beaucoup de technologie en interne — supports connectés, outils
            de suivi, sites internet. Mais ce qui fait la différence, c'est
            l'accompagnement sur mesure de chaque enseigne.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.title}
                data-testid={`process-step-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="relative bg-background border border-border p-8 hover:border-accent/40 transition-colors"
              >
                <span className="font-mono text-5xl font-bold text-white/5 absolute top-4 right-6">
                  0{i + 1}
                </span>
                <div className="w-12 h-12 flex items-center justify-center border border-accent/40 bg-accent/5 text-accent mb-6">
                  <Icon size={22} />
                </div>
                <h3 className="font-heading font-semibold text-xl mb-3">{s.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
